/* eslint-disable @typescript-eslint/naming-convention */

import { AppDispatchType, RootStateType } from 'store'
import {
  GetAssetListRequestType,
  getAssetList,
  getRejectReasonList,
  putUnassignAsset,
  postGenerateAsset,
  PostGenerateAssetRequestType,
  PutUnassignAssetRequestType,
} from 'features/SupplyOrder/services/generateAssetId'
import { callErrorMsg } from 'helpers/errorMsg'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  FetchLocationListRequestType,
  getLocationListAPI,
} from 'features/Enterprise/Account/services'
import { getAssetInventoryListAPI } from 'features/AssetManagement/services/supplyOrder'
import { GenerateAssetIdInitStateType } from 'features/SupplyOrder/@types/GenerateAssetId'
import { setIsLoading, setListData, setSupplyOrderMovableAssets } from './slice'

const getParamsType = (queryParams: GenerateAssetIdInitStateType['queryParams']) => {
  const paramData: GetAssetListRequestType = {
    'pagination.page_size': queryParams.pageSize || 20,
    'pagination.page_index': queryParams.pageIndex || 1,
  }
  if (queryParams.assetCode) {
    paramData['filter.asset_code'] = queryParams.assetCode
  }

  if (queryParams.locationId) {
    paramData['filter.location_id'] = queryParams.locationId
  }

  return paramData
}

export const actFetchGenerateAssetList =
  () => async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    dispatch(setIsLoading(true))
    try {
      const { queryParams } = getState().generateAssetId
      const paramsData = getParamsType(queryParams)
      const { data } = await getAssetList(paramsData)
      dispatch(setListData(data.data))
    } catch (err) {
      callErrorMsg(err)
    } finally {
      dispatch(setIsLoading(false))
    }
  }

export const fetchReasons = createAsyncThunk(
  `generateAsset/fetchReasons`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getRejectReasonList({
        'pagination.page_index': 0,
        'pagination.page_size': 100,
        'filter.type': 'UNASSIGN_ASSET',
      })

      return data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const actSubmitUnassign = createAsyncThunk(
  `generateAsset/actSubmitUnassign`,
  async (payload: PutUnassignAssetRequestType, { rejectWithValue }) => {
    try {
      const { data } = await putUnassignAsset(payload)

      return data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const fetchLocations = createAsyncThunk(
  `generateAsset/fetchLocations`,
  async (params: FetchLocationListRequestType, { rejectWithValue }) => {
    try {
      const { data } = await getLocationListAPI(params)
      return data.content
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchSupplyOrderMovableAssets = createAsyncThunk(
  `generateAsset/fetchSupplyOrderMovableAssets`,
  async (
    params: { origin_id: string; search_params?: string; page_index?: number; page_size?: number },
    { dispatch },
  ) => {
    const assetCategoryID = [8, 140, 141, 142, 143]
    const status = 'available'
    try {
      const { data } = await getAssetInventoryListAPI({
        origin_id: params.origin_id,
        search_params: params.search_params,
        page_index: params.page_index,
        page_size: params.page_size,
        asset_category_ids: assetCategoryID,
        status,
      })
      dispatch(setSupplyOrderMovableAssets(data.data))
    } catch (error) {
      callErrorMsg(error)
    }
  },
)

export const generateAsset = createAsyncThunk(
  `generateAsset/generateAsset`,
  async (payload: PostGenerateAssetRequestType, { rejectWithValue }) => {
    try {
      const { data } = await postGenerateAsset(payload)
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
